<template>
  <v-data-table
    :headers="headers"
    :items="items"
    sort-desc
    calculate-widths
    class="settings-dt"
    hide-default-footer
    height="calc(100vh - 48px)"
    :loading="loading"
    :footer-props="{'items-per-page-options': [-1]}"
    :items-per-page="-1"
  >
    <template v-slot:item.action="{ item }">
      <v-btn
        text
        title="Save All"
        class="px-0"
        style="min-width: 36px"
        @click="save(item)"
      >
        <v-icon>mdi-content-save-all</v-icon>
      </v-btn>
    </template>
    <template v-slot:item.row_num="{ item }">
      <span class="row_num"></span>
    </template>
    <template v-slot:item.settings="{ item }">
      <v-combobox
        v-if="isArray(item.settings)"
        :value="item.settings"
        :items="item.settings"
        :search-input.sync="item.search"
        hide-selected
        label=""
        multiple
        persistent-hint
        small-chips
        @input="item.settings = $event.map(val => val.trim())"
      >
        <template v-slot:no-data>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>
                Press <kbd>enter</kbd> to create a new one
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-combobox>

      <template
        v-else-if="isObject(item.settings)"
      >
        <vue-json-editor
          v-model="item.settings"
          mode="code"
          :modes="[]"
          :show-btns="false"
          :exapndedOnStart="true"
        />
        <non-ascii-alert :source-object="item.settings" />
      </template>
      <v-text-field
        v-else-if="isString(item.settings) && item.key==='notification_user_amount'"
        v-model="item.settings"
        label="Amount EUR for notification"
        hide-details
      ></v-text-field>
      <v-text-field
        v-else-if="isString(item.settings) && item.key==='socket_notification_url'"
        v-model="item.settings"
        label="Socket URL for notification"
        hide-details
      ></v-text-field>
    </template>
  </v-data-table>
</template>

<style>

  .settings-dt tr:not(.report-filter-row) {
    counter-increment: row-num;
  }

  .settings-dt tr td:first-child .row_num::before {
    content: counter(row-num) ". ";
  }

  .jsoneditor-menu {
    display: none !important;
  }

  /*div.jsoneditor-mode-code {*/
  /*  height: 340px;*/
  /*}*/

  div.jsoneditor-outer {
    padding-top: 0px;
    margin-top: 0px;
  }

</style>

<script>
  import vueJsonEditor from 'vue-json-editor'
  import { isArray, isNumber, isObject, isString } from 'lodash'
  import { API } from '@/utils/api'
  import NonAsciiAlert from './NonAsciiAlert.vue'

  export default {

    components: {
      vueJsonEditor,
      NonAsciiAlert,
    },

    data: () => ({
      loading: false,
      headers: [
        { text: '#', value: 'row_num', sortable: false },
        { text: 'Key', value: 'key' },
        { text: 'Value', value: 'settings' },
        { text: '', value: 'action' },
      ],
      items: []
    }),

    mounted () {
      this.load()
    },

    methods: {
      isString,
      isNumber,
      isArray,
      isObject,

      save (item) {
        this.loading = true
        return API.call('/settings/update.json', item).then(resp => {
          item = resp.data
        }).finally(() => {
          this.loading = false
        }).then(r => this.load())
      },
      load () {
        this.loading = true
        return API.call('/settings/list.json', {}).then(resp => {
          this.items = resp.data
        }).finally(() => {
          this.loading = false
        })
      },
    },

  }
</script>

